import { createContext, useContext } from "react";
import { useAuth } from "react-oidc-context";
const AuthTokenContext = createContext<string | null>(null);
export const AuthTokenProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const auth = useAuth();
  const token = auth.user?.access_token ?? null;
  return (
    <AuthTokenContext.Provider value={token}>
      {children}
    </AuthTokenContext.Provider>
  );
};
export const useAuthToken = () => useContext(AuthTokenContext);
